<template>
  <div class="leftside">
    <img src="logo_novati.jpg" v-on:click.stop="toHome" style="cursor: pointer;"/>

    <div class="langs">
      <router-link :to="{ name: 'about', params: { lang: 'it' }}">BIO IT</router-link>
      |
      <router-link :to="{ name: 'about', params: { lang: 'en' }}">BIO EN</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftSide',
  methods: {
    toHome() {
      // console.log((this.$router.history.current.name));
      // if (this.$router.history.current.name == "home") {
      this.$router.push({ name: "home", params: { } });
      // }   
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .langs a {
      color: black;
      font-size: small;
    }
</style>
